import { useStyles } from './styles/SystemFilters.styles';
import { SystemModelMap, SystemStatus, SystemFilterOption, SystemAssigned } from '@consts/systems';
import { SearchBar } from '@components/SearchBar';
import { useMemo, type Dispatch, type SetStateAction } from 'react';

import type { SystemFilter } from '@/types/systems';
import { OrgFilters } from '@components/OrgFilters';
import { MultiSelectFilter } from '@components/MultiSelectFilter';
import { FormControlLabel, Switch, Typography, ToggleButton, ToggleButtonGroup, Box } from '@mui/material';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import PersonIcon from '@mui/icons-material/Person';

import SystemSecurityUpdateGoodIcon from '@mui/icons-material/SystemSecurityUpdateGood';
import SystemSecurityUpdateWarningIcon from '@mui/icons-material/SystemSecurityUpdateWarning';
import { useSelector } from 'react-redux';
import type { RootState } from '@features/redux/store';

const statusOptions = Object.keys(SystemStatus);

interface SystemTableFiltersProps {
    filters: SystemFilter;
    setFilter: (key: string, value: string, selectOne?: boolean) => void;
    setAssigned: (value: SystemAssigned) => void;
    searchTerm: string;
    assigned: SystemAssigned;
}

export const SystemTableFilters = ({
    filters,
    setFilter,
    assigned,
    setAssigned,
    searchTerm,
}: SystemTableFiltersProps) => {
    const classes = useStyles();

    const models = useMemo(
        () =>
            Object.entries(SystemModelMap).map(([modelNumber, modelName]) => ({
                modelNumber: +modelNumber,
                modelName,
            })),
        []
    );

    const { role } = useSelector((state: RootState) => state.auth.Roles);

    return (
        <>
            <MultiSelectFilter
                label={'Model'}
                options={models}
                idKey={'modelNumber'}
                value={filters.model}
                onChange={(value: { modelNumber: number; modelName: string }) =>
                    setFilter(SystemFilterOption.Model, value.modelNumber.toString(), true)
                }
                getLabelValue={(option) => option.modelName}
                disabled={Boolean(searchTerm)}
            />

            <MultiSelectFilter
                search
                label={'Status'}
                options={statusOptions}
                value={filters.status}
                onChange={(value) => setFilter(SystemFilterOption.Status, value)}
                getLabelValue={(option) => option}
                disabled={Boolean(searchTerm)}
            />

            {role.isAdmin && role.stores.edit && (
                <ToggleButtonGroup
                    value={assigned}
                    exclusive
                    onChange={(_, value) => {
                        if (value !== null) {
                            setAssigned(value);
                        }
                    }}
                    disabled={Boolean(searchTerm)}
                    size='small'
                    className={classes.toggleGroup}>
                    <ToggleButton value={SystemAssigned.Assigned} className={classes.toggleButton}>
                        {/* <SystemSecurityUpdateGoodIcon sx={{ fontSize: '20px', mr: 1 }} /> */}
                        Assigned
                    </ToggleButton>
                    <ToggleButton value={SystemAssigned.Unassigned} className={classes.toggleButton}>
                        {/* <SystemSecurityUpdateWarningIcon sx={{ fontSize: '20px', mr: 1 }} /> */}
                        Unassigned
                    </ToggleButton>
                </ToggleButtonGroup>
            )}
        </>
    );
};
